var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7147 4.55873C24.0382 4.66421 24.3198 4.86187 24.5214 5.12492C24.723 5.38797 24.8349 5.7037 24.8418 6.02932V16C24.8713 18.0633 24.2941 20.0934 23.1754 21.8606C22.0567 23.6278 20.4412 25.0615 18.5116 25.9998L13.0152 28.8234L7.5033 25.9851C6.21601 25.3628 5.06364 24.5147 4.10665 23.4852C2.20471 21.4066 1.15717 18.7425 1.15772 15.9852V6.02932C1.16461 5.7037 1.27646 5.38797 1.47807 5.12492C1.67967 4.86187 1.96131 4.66421 2.28481 4.55873L12.4439 1.14704C12.8042 1.0294 13.1953 1.0294 13.5556 1.14704L23.7147 4.55873Z",
    stroke: "#0D1444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98584 14.5881L11.9039 17.3823L17.9252 11.647",
    stroke: "#0D1444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.2f9da4a5c05177b30f7476f725b2bfa9.svg";
export { ForwardRef as ReactComponent };